<template>
  <div>
    <Header />
    <SideNavMobile />
    <SideNav />
    <div class="ba-content-container" uk-height-viewport="expand: true; min-height: 100vh;">
      <div class="uk-container uk-container-expand">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  // Components
  import Header from '@/components/portal/header.vue';
  import SideNav from '@/components/portal/sidenav.vue';
  import SideNavMobile from '@/components/portal/sidenavmobile.vue'

  export default {
    name: 'portal-layout',
    components: {
      Header,
      SideNav,
      SideNavMobile
    },
    metaInfo: {
      title: 'BitAccel | Portal',
      htmlAttrs: {
        lang: 'en'
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../../node_modules/uikit/src/less/uikit.less";
  @import "../../assets/less/theme.less";

@media (min-width: @breakpoint-medium) {
  .ba-sidebar-left + .ba-content-container {
    padding-left: 240px;
  }
}
.ba-content-container {
  padding: 0 0 0 0;
  background-color: @ba-off-white;
}
</style>
